import React, { Component } from "react"
//import ReactDOM from "react-dom"
//import { Link } from "gatsby"

import { styles } from "../utils"

import styled from "styled-components"

class IFrame extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Paragrafos1 gameSize={this.props.gameSize}>
        {this.props.sizes.map(s => (
          <button
            style={{
              letterSpacing: "5px",
              position: "relative",
              padding: "5px",
              //left: "150px",
              backgroundColor: "#161823",
              //border: "5px solid red",
              textIndent: "0.5rem",
              margin: "10px 10px 5px 0px",
              color: "white",
            }}
            onClick={() => this.props.handleSizeChange(s)}
          >
            {s.name}{" "}
          </button>
        ))}

        <iframe
          src={this.props.src}
          scrolling="no"
          frameborder="0"
          title="dummy"
          style={{ height: "100%", width: "100%" }}
        ></iframe>
      </Paragrafos1>
    )
  }
}

export default IFrame

const Paragrafos1 = styled.div`
  width: ${props => {
    return props.gameSize.width
  }};
  height: ${props => {
    return props.gameSize.height
  }};
  //border: 1px solid black;
  transition: all 1s;

  margin: 2rem auto;
  .text {
    line-height: 2rem;
    color: ${styles.colors.mainGrey};
    word-spacing: 2rem;
  }
`
